module.exports = __webpack_public_path__ + "static/media/orders_arrow.4526e363.svg";